import { Link } from "react-router-dom";
import LoopWatermark from "../../Components/Brand/LoopWatermark";
import { ArrowIcon } from "../../Components/Brand/Icons";
import StationTrack from "../../Components/Track/StationTrack";
import { PROCESS, SERVICES } from "../../content/services";
import Seo from "../../seo/Seo";
import { SITE_URL, breadcrumbSchema } from "../../seo/site";
import RouteLine from "../../Components/Track/RouteLine";
import ServiceShowcase from "./ServiceShowcase";
import "./services.css";

/** One Service entry per offering, linked to the business on Home. */
const servicesSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Infinitude Stack services",
  itemListElement: SERVICES.map((s, i) => ({
    "@type": "ListItem",
    position: i + 1,
    item: {
      "@type": "Service",
      "@id": `${SITE_URL}/services#${s.id}`,
      name: s.name,
      description: s.long,
      serviceType: s.name,
      provider: { "@id": `${SITE_URL}/#organization` },
      areaServed: { "@type": "Country", name: "Canada" },
    },
  })),
};

const ServicesPage = () => {
  return (
    <>
      <Seo
        path="/services"
        title="Web, Mobile & Cloud Development Services | Infinitude Stack"
        description="Web development, iOS & Android apps, cloud & DevOps, UX/UI design, QA testing, digital marketing and support — one team in Kitchener, Ontario."
        schema={[servicesSchema, breadcrumbSchema("Services", "/services")]}
      />

      <div className="is-services">
        {/* ---------- Hero ---------- */}
        <section className="is-container is-services-hero">
          <h1 className="is-display is-services-hero__title">
            Everything your product needs, <strong className="is-accent-text">in one team.</strong>
          </h1>
          <p className="is-lede is-services-hero__lede">
            From early research to years of support after launch, we cover every
            layer of your product — so nothing falls between vendors.
          </p>
          <RouteLine
            size="lg"
            label="Jump to a service"
            endSuffix="↺"
            stops={SERVICES.map((s, i) => ({
              num: String(i + 1).padStart(2, "0"),
              label: s.navLabel,
              href: `#${s.id}`,
            }))}
          />
        </section>

        {/* ---------- The seven services ---------- */}
        {/* ---------- The seven services: scroll-driven showcase ---------- */}
        <ServiceShowcase />

        {/* ---------- How a project runs ---------- */}
        <section className="is-services-process" aria-labelledby="services-process-title">
          <LoopWatermark />
          <div className="is-container">
            <div className="is-section-head is-section-head--dark is-reveal">
              <div>
                <p className="is-eyebrow">How we work</p>
                <h2 id="services-process-title" className="is-display is-h2">
                  How a project <strong>runs.</strong>
                </h2>
              </div>
            </div>
            <StationTrack items={PROCESS} tone="dark" loops />
          </div>
        </section>

        {/* ---------- CTA: rounded navy panel ---------- */}
        <section className="is-services-cta" aria-labelledby="services-cta-title">
          <div className="is-services-cta__panel is-reveal">
            <div>
              <p className="is-eyebrow is-services-cta__eyebrow">Transparent from day one</p>
              <h2 id="services-cta-title" className="is-display is-services-cta__title">
                Know the plan <strong>before we start.</strong>
              </h2>
            </div>
            <Link to="/contact" className="is-btn is-btn--accent">
              Talk to us
              <span className="is-btn__arrow">
                <ArrowIcon />
              </span>
            </Link>
          </div>
        </section>
      </div>
    </>
  );
};

export default ServicesPage;
